/*
 * Module for polling the HealthChecks endpoint and updating a grid with the results.
 */

rs.module("content/diagnostics/health",

    [/* dependencies */],

    function () {

        var _columnIds;

        function initialize(healthUrl, lrsGridApi, columnIds) {

            _columnIds = columnIds;
            var agGridApi = lrsGridApi.agGridApi;
            var firstData = true;

            // setup sort order
            agGridApi.applyColumnState({
                state: [ { colId: columnIds.Name, sort: 'asc' } ]
            });

            // initial data retrieve
            _retrieveHealthData();

            // update data every few seconds
            setInterval(_retrieveHealthData, 5000);


            /// Retrieve and display health data
            function _retrieveHealthData() {
                $.getJSON(healthUrl, { detailed: true })
                    .done(function (results) {

                        // transform hierarchical results to a table
                        var data = results.Checks.reduce(function (accumulation, check) {
                            check.Data.map(function (checkData) {
                                checkData[columnIds.HealthCheck] = check.Description;
                                checkData[columnIds.Status] = check.Status;

                                accumulation.push(checkData);
                            });

                            return accumulation;
                        }, []);

                        if (firstData) {
                            agGridApi.applyTransactionAsync({ add: data });
                            firstData = false;
                        }
                        else {
                            agGridApi.applyTransactionAsync({ update: data });
                        }
                    });
            }

        }

        // getRowId grid callback for assigning a row id, letting us quickly update records 
        // for which we're notified of changes. 
        function getRowId(params) {
            // construct a composite key
            return params.data[_columnIds.HealthCheck] + params.data[_columnIds.Name];
        };

        /// the interface to the control
        var exports = {
            initialize: initialize,
            getRowId: getRowId
        };

        return exports;
    }
);
